<!--
 * @Descripttion: 
 * @Author: lijingjing56
 * @Date: 2025-01-06 14:37:54
 * @LastEditors: lijingjing56
 * @LastEditTime: 2025-01-21 15:37:24
-->
<template>
  <div class="product-service-section-container">
      <section-title :text="title" :mess="polutionData.mess"/>
      <div class="section-main">
        <img :src="polutionData.imgUrl" class="cls-img">
      </div>
  </div>
</template>

<script>
import sectionTitle from "../../components/sectionTitle.vue";
export default {
name: "polutionPart",
components: {
  sectionTitle: sectionTitle
},
props: {
  pageKey: {
    type: String,
    default: ''
  },
  mess: {
    type: String,
    default: ""
  },
  title: {
    type: String,
    default: "解决方案"
  },
  polutionData:{
    type: Object,
    default: {}
  },
  hasLink: {
    type: Boolean,
    default: true
  }
},
methods: {
}
};
</script>

<style lang="scss" scoped>
.product-service-section-container {
width: 100%;
padding: 86px 0 0px;
background: linear-gradient(180deg, #f0f2ff 0%, #fbfcff 48.13%, white 100%);

.section-main {
  height: 100%;
  margin: 50px auto 0;
  display: flex;
  justify-content: center;
  padding-bottom: 30px;
  .cls-img{
    margin-bottom:50px;
    max-width:1680px;
  }
}
}
</style>

